import React, { useEffect, useState } from 'react';

import css from './PromoModal.module.css';
import styles from '../DiscountBanner/DiscountBanner.module.css';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

const PromoModal = ({ isAuthenticated, isOpen, onClose }) => {
  const intl = useIntl();

  if (!isOpen) return null;

  const handleLinkClick = () => onClose();

  return (
    <div className={css.modalOverlay}>
      <div className={css.promoContainer}>
        <button className={css.closeButton} onClick={onClose}>×</button>
        <div className={css.promoContent}>
          <h2 className={css.promoTitle}>
            {intl.formatMessage({ id: 'discountBanner.titlePopup' })}
          </h2>

          {!isAuthenticated ? (
            <Link to="/signup" onClick={handleLinkClick}>
              <button className={styles.button}>
                {intl.formatMessage({ id: 'discountBanner.buttonPopup' })}
              </button>
            </Link>
          ) : (
            <Link to="/s?keywords=" onClick={handleLinkClick}>
              <button className={styles.button}>
                {intl.formatMessage({ id: 'PromoModal.ctaButton' })}
              </button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default PromoModal;
